import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/sticky-notes';

const stickyNoteService = {
  async fetchNotes(params = {}) {
    try {
      const resp = await axiosInstance.get(BASE_PATH, { params });
      if (Array.isArray(resp?.data?.notes)) {
        return resp.data.notes;
      }
      return [];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('stickyNoteService.fetchNotes failed', err);
      throw err;
    }
  },

  async createNote(payload) {
    try {
      const resp = await axiosInstance.post(BASE_PATH, payload);
      return resp?.data?.note || null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('stickyNoteService.createNote failed', err);
      throw err;
    }
  },

  async updateNote(noteId, payload) {
    try {
      const resp = await axiosInstance.put(`${BASE_PATH}/${noteId}`, payload);
      return resp?.data?.note || null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('stickyNoteService.updateNote failed', err);
      throw err;
    }
  },

  async updateStatus(noteId, status) {
    try {
      const resp = await axiosInstance.patch(`${BASE_PATH}/${noteId}/status`, { status });
      return resp?.data?.note || null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('stickyNoteService.updateStatus failed', err);
      throw err;
    }
  },

  async updatePin(noteId, isPinned) {
    try {
      const resp = await axiosInstance.patch(`${BASE_PATH}/${noteId}/pin`, { isPinned });
      return resp?.data?.note || null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('stickyNoteService.updatePin failed', err);
      throw err;
    }
  },

  async deleteNote(noteId) {
    try {
      await axiosInstance.delete(`${BASE_PATH}/${noteId}`);
      return true;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('stickyNoteService.deleteNote failed', err);
      throw err;
    }
  },
};

export default stickyNoteService;
